/**
 * Vue route and admin JSON prefix. Must match server ADMIN_ROUTE_PREFIX.
 * Baked in at Vite build time.
 */
export function adminClientPath(): string {
  const raw = import.meta.env.VITE_ADMIN_PATH || '/__ops'
  if (typeof raw !== 'string' || !raw.startsWith('/') || raw.startsWith('//')) {
    return '/__ops'
  }
  const trimmed = raw.replace(/\/+$/, '')
  return trimmed || '/__ops'
}

const KEY = 'dc-admin-key'

export function readAdminKey(): string {
  try {
    return sessionStorage.getItem(KEY) || ''
  } catch {
    return ''
  }
}

export function writeAdminKey(value: string): void {
  try {
    if (value) sessionStorage.setItem(KEY, value)
    else sessionStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}
